import React from "react";
import api from "../../../api/Api";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {NavLink} from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Loader from "../../../components/Loader";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import {dashboardRouter} from "../../../util/globalHelper"
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";

class UserRoleAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            usernameState: "",
            username: "",
            password: "",
            passwordState: "",
            clinicmaster_id: "",
            clinic_id: "",
            clinic_permission_id: "",
            registerEmail: "",
            phoneNumber: "",
            registerEmailState: "",
            phoneNumberState: "",
            name: "",
            last_name: "",
            is_doctor: false,
            nameState: "",
            last_nameState: "",
            alert: null,
            open: true,
            clinicRoles: null,
            clinicsData: null,
            validation: null
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
        this.onCheckDoctor = this.onCheckDoctor.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.generateNotification = this.generateNotification.bind(this);
        this.NotificationDone = this.NotificationDone.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this);


    }

    componentDidMount() {
        this.CallReadApi()
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    onCheckDoctor(e) {
        const state = this.state;
        state[e.target.name] = e.target.checked;
        this.setState(state);
    }

    getMyclinicRoles(id) {
        api.getPermissionForClinic(id).then(json => {
            this.setState({clinicRoles: json.data})
        });
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    render() {
        const {classes} = this.props;
        if (this.state.clinicmaster_id && this.state.clinicRoles === null) {
            this.getMyclinicRoles(this.state.clinicmaster_id)
        }

        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }

        const {data, clinicRoles, clinicsData} = this.state;
        if (this.state.data)
            return (<GridContainer>
                    {this.state.alert}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" text>
                                <CardText color="info">
                                    <h4>Add User</h4>
                                </CardText>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <form>
                                            <GridContainer justify="center">
                                                <GridItem xs={12} sm={5} md={5}>
                                                    <CustomInput
                                                        labelText="Username"
                                                        id="username"
                                                        success={this.state.usernameState === "success"}
                                                        error={this.state.usernameState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "username", "alphanum", "required")
                                                        }}
                                                    />
                                                    <small>{this.state.validation === true ? "Username available" : this.state.validation === false ? "Username not avalibale" : null}</small>
                                                </GridItem>
                                                <GridItem xs={12} sm={5} md={5}>
                                                    <CustomInput
                                                        labelText="Name"
                                                        id="name"
                                                        success={this.state.nameState === "success"}
                                                        error={this.state.nameState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "name", "name", "required")
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={5} md={5}>
                                                    <CustomInput
                                                        labelText="Password"
                                                        id="password"
                                                        success={this.state.passwordState === "success"}
                                                        error={this.state.passwordState === "error"}
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "password", "alphanum", "required"),
                                                            type: "password"
                                                        }}
                                                    />
                                                </GridItem>
                                                {/*<GridItem xs={12} sm={5} md={5}>*/}
                                                {/*<CustomInput*/}
                                                {/*labelText="Last Name"*/}
                                                {/*id="last_name"*/}
                                                {/*success={this.state.last_nameState === "success"}*/}
                                                {/*error={this.state.last_nameState === "error"}*/}
                                                {/*formControlProps={{*/}
                                                {/*fullWidth: true,*/}
                                                {/*required: true*/}
                                                {/*}}*/}
                                                {/*inputProps={{*/}
                                                {/*onChange: event =>*/}
                                                {/*this.change(event, "last_name", "name", "required")*/}
                                                {/*}}*/}
                                                {/*/>*/}
                                                {/*</GridItem>*/}
                                                <GridItem xs={12} sm={7} md={5}>
                                                    <CustomInput
                                                        success={this.state.registerEmailState === "success"}
                                                        error={this.state.registerEmailState === "error"}
                                                        labelText="Email "
                                                        id="registeremail"
                                                        formControlProps={{
                                                            fullWidth: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "registerEmail", "email", "optional"),
                                                            type: "email"
                                                        }}
                                                    />
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <br/>
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {data.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>

                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <CustomInput
                                                        labelText="Phone Number"
                                                        success={this.state.phoneNumberState === "success"}
                                                        error={this.state.phoneNumberState === "error"}
                                                        id="phonenumber"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event =>
                                                                this.change(event, "phoneNumber", "phonenumber", "required")
                                                        }}
                                                    />

                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <br/>
                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?

                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem disabled>
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem>
                                                <GridItem xs={12} sm={6} md={5}>
                                                    <br/><br/>
                                                    <InputLabel>
                                                        Is Doctor
                                                    </InputLabel>&nbsp;&nbsp;
                                                    <input type={"checkbox"} name={"is_doctor"}
                                                           onChange={this.onCheckDoctor} value={this.state.is_doctor}/>
                                                </GridItem>
                                            </GridContainer>

                                            {this.state.clinicRoles && this.state.clinicRoles[0].clinic_master_id === this.state.clinicmaster_id ?
                                                <GridContainer justify="center">
                                                    <GridItem xs={12} sm={6} md={5}>
                                                        <br/>
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_permission_id">
                                                                Choose Role
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_permission_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_permission_id",
                                                                    id: "clinic_permission_id"
                                                                }}
                                                            >
                                                                <MenuItem disabled>
                                                                    Select Role
                                                                </MenuItem>
                                                                {clinicRoles.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.role_name ? x.role_name : "No Name"}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                        <br/><br/>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={6} md={5}>
                                                        <br/>
                                                    </GridItem>
                                                </GridContainer> : null}
                                        </form>
                                        <CardFooter className={classes.justifyContentCenter}>
                                            <GridContainer className={classes.justifyContentCenter}>
                                                <br/><br/>
                                                <GridItem xs={12} sm={3}>
                                                    <Button block type={"submit"} color="warning"
                                                            onClick={this.onSubmit}>
                                                        Add
                                                    </Button>
                                                </GridItem>
                                                <GridItem xs={12} sm={3}>
                                                    <NavLink to={dashboardRouter(`/roles/user`)}>
                                                        <Button block color="grey">
                                                            Cancel
                                                        </Button>
                                                    </NavLink>
                                                </GridItem>
                                            </GridContainer>
                                        </CardFooter>
                                    </GridItem>
                                </GridContainer></CardBody></Card></GridItem></GridContainer>
            );
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = () => {
        api.listClinicMaster().then(json => {
            if (!json.data.isError) {
                this.setState({data: json.data.data})
            }
        });
    }

    onSubmit() {
        if (this.state.name === "") {
            this.setState({nameState: "error"});
        }
        if (this.state.username === "") {
            this.setState({usernameState: "error"});
        }
        if (this.state.password === "") {
            this.setState({passwordState: "error"});
        }
        if (this.state.phoneNumber === "") {
            this.setState({phoneNumberState: "error"});
        }
        if (this.state.nameState === "success" &&
            this.state.passwordState === "success" &&
            this.state.phoneNumberState === "success" &&
            this.state.usernameState === "success" && this.state.clinic_permission_id !== "" && this.state.clinicmaster_id !== "" && this.state.clinic_id !== "") {
            const postBody = this.state.is_doctor ? {
                "name": this.state.name,
                "clinic_master_id": this.state.clinicmaster_id,
                "clinic_permission_id": this.state.clinic_permission_id,
                "email": this.state.registerEmail,
                "user_name": this.state.username,
                "password": this.state.password,
                "contact": this.state.phoneNumber,
                "is_doctor": "is_doctor",
                "clinic_id": this.state.clinic_id
            } : {
                "name": this.state.name,
                // "last_name": this.state.last_name,
                "clinic_master_id": this.state.clinicmaster_id,
                "user_name": this.state.username,
                "password": this.state.password,
                "contact": this.state.phoneNumber,
                "clinic_permission_id": this.state.clinic_permission_id,
                "email": this.state.registerEmail,
                "clinic_id": this.state.clinic_id
            }
            api.AllUserToClinic(postBody).then(json => {
                if (json.data.isError === false) {
                    var msgcolor = {message: "User added Successfully!", color: "success"};
                    this.CreateAlert(msgcolor.message)
                    this.generateNotification(msgcolor);
                } else {
                    var msgcolor = {message: "Error in adding!", color: "danger"};
                    this.generateNotification(msgcolor);
                }
            }).catch(err => {
                var msgcolor = {message: "Error in adding!", color: "danger"};
                this.generateNotification(msgcolor);
            })
        }
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        if (stateName === "username" && this.state.username.length > 3 && this.state.usernameState === "success") {
            api.validateUser({"username": event.target.value}).then(json => {
                this.setState({validation: json.data.data.valid})

            })
        }
        switch (type) {
            case "email":
                if (this.verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (this.verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (this.verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (this.verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (this.verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyName(value) {
        var nameRex = /^(?![ .]+$)[a-zA-Z .]+$/;
        if (nameRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyAlphaNum(value) {
        var alphanumRex = new RegExp("^[0-9a-zA-Z]+$");
        if (alphanumRex.test(value)) {
            return true;
        }
        return false;
    }

    verifyPhoneNumber(value) {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value) && value.length === 10) {
            return true;
        }
        return false;
    }

    generateNotification(msgcolor) {
        this.setState({message: msgcolor.message}, () => {
            this.setState({color: msgcolor.color}, () => {
                this.setState({showNotification: true}, () => {
                    this.showNotification("tc")
                })
            })
        });
    }

    showNotification(place) {
        if (!this.state[place]) {
            var x = [];
            x[place] = true;
            this.setState(x);
            // use this to make the notification autoclose
            setTimeout(
                function () {
                    x[place] = false;
                    this.setState(x);
                    this.NotificationDone();
                }.bind(this),
                4000
            );
        }
    }

    NotificationDone() {
        this.setState({message: ''});
    }

    CreateAlert(reason) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{reason}</DialogTitle>

                    <DialogActions>
                        <Button onClick={this.hideAlert}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
        this.props.history.push("/roles/user")
    }
}

//export default UserRoleAdd
export default withStyles(validationFormsStyle)(UserRoleAdd);



// WEBPACK FOOTER //
// ./src/views/Roles/User/UserRoleAdd.jsx